import ParseClient, { Parse } from "./parseDataProvider";
import ParseAuth from "./parseAuth";
import { localDataProvider } from "./localDataProvider";
const parseConfig = {
  URL: process.env.REACT_APP_API_URL,
  JAVASCRIPT_KEY: process.env.REACT_APP_JAVASCRIPT_KEY,
  APP_ID: process.env.REACT_APP_APP_ID,
  MASTER_KEY: process.env.REACT_APP_MASTER_KEY,
};
const localResources = [
  {
    name: "ApplicationSetting",
    defaultState: [
      {
        name: "Photoshop",
        path: "",
      },
    ],
  },
];
Parse.initialize(parseConfig.APP_ID, parseConfig.JAVASCRIPT_KEY);
Parse.serverURL = parseConfig.URL;

export const dataProvider = localDataProvider(
  localResources,
  ParseClient(parseConfig)
);

export const extendedDataProvider = {
  ...dataProvider,
  update: async (resource, params) => {
  
    if (resource !== "User") {
      return dataProvider.update(resource, params);
    }
    try {
      
      const result = await Parse.Cloud.run("UpdateUser", {
        params: JSON.stringify(params),
      });
      return { data: result };
    } catch (error) {
      throw error.toString();
    }
  },
  delete: async (resource, params) => {
    if (resource !== "User") {
      return dataProvider.delete(resource, params);
    }
    try {
      const result = await Parse.Cloud.run("DeleteUser", { params });
      return { data: result };
    } catch (error) {
      throw error.toString();
    }
  },
  deleteMany: async (resource, params) => {
    if (resource !== "User") {
      return dataProvider.deleteMany(resource, params);
    }
    try {
      const result = await Parse.Cloud.run("DeleteMany", { params });
      return { data: result };
    } catch (error) {
      throw error.toString();
    }
  },
};

export const authProvider = ParseAuth(parseConfig);
export default Parse;
